export default __webpack_public_path__ + "static/media/2024_Letten_et_al_2024_EcologyLetters.a80e9649.pdf";